export default __webpack_public_path__ + "static/media/icon-arrow-order-selected.027762fc.svg";